import { CARE_STATE_PROBLEM_HISTORY_TAB_ID } from '@/features/care-state-problems-tab';
import { CARE_STATE_REQUESTS_TAB_ID } from '@/features/care-state-requests-tab';

export const PATIENT_REQUESTS_TAB_ID = CARE_STATE_REQUESTS_TAB_ID;
export const PATIENT_PROBLEM_HISTORY_TAB_ID = CARE_STATE_PROBLEM_HISTORY_TAB_ID;
export const PATIENT_RX_ORDERS_TAB_ID = 'rx:orders';
export const PATIENT_LAB_ORDERS_TAB_ID = 'lab:orders';
export const PATIENT_HEALTH_RECORDS_TAB_ID = 'health-records';
export const PATIENT_PRIOR_AUTHS_TAB_ID = 'prior-auths';
export const PATIENT_RX_INBOX_TAB_ID = 'rx:inbox';

export type PatientWorkspaceTabId =
  | typeof PATIENT_REQUESTS_TAB_ID
  | typeof PATIENT_PROBLEM_HISTORY_TAB_ID
  | typeof PATIENT_RX_ORDERS_TAB_ID
  | typeof PATIENT_LAB_ORDERS_TAB_ID
  | typeof PATIENT_HEALTH_RECORDS_TAB_ID
  | typeof PATIENT_PRIOR_AUTHS_TAB_ID
  | typeof PATIENT_RX_INBOX_TAB_ID;
